
import React, { useState, useEffect, useRef } from 'react';

function Header() {
  const [tilt, setTilt] = useState({ x: 0, y: 0 });
  const [isMobile, setIsMobile] = useState(false);
  const permissionRequested = useRef(false);

  useEffect(() => {
    // Detect if device supports touch (mobile/tablet)
    const mobile = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    setIsMobile(mobile);
  }, []);

  useEffect(() => {
    const handleMouseMove = (e) => {
      if (isMobile) return; // Skip mouse events on mobile
      
      // Calculate mouse position relative to viewport center
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;

      // Calculate the distance from center as a percentage
      const deltaX = (e.clientX - centerX) / (window.innerWidth / 2);
      const deltaY = (e.clientY - centerY) / (window.innerHeight / 2);

      // Apply tilt with a max rotation of 15 degrees
      const maxTilt = 15;
      setTilt({
        x: -deltaY * maxTilt, // Negative to make tilt feel natural
        y: deltaX * maxTilt
      });
    };

    const handleDeviceOrientation = (e) => {
      // beta is front-to-back tilt (-180 to 180)
      // gamma is left-to-right tilt (-90 to 90)
      const beta = e.beta || 0;
      const gamma = e.gamma || 0;

      // Normalize the values and apply tilt
      // For mobile, we want more dramatic movement
      const maxTilt = 25;
      
      setTilt({
        x: Math.max(-maxTilt, Math.min(maxTilt, beta / 3)),
        y: Math.max(-maxTilt, Math.min(maxTilt, gamma / 2))
      });
    };

    const requestPermission = async () => {
      if (permissionRequested.current) return;
      permissionRequested.current = true;

      try {
        if (typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function') {
          const permission = await DeviceOrientationEvent.requestPermission();
          if (permission === 'granted') {
            window.addEventListener('deviceorientation', handleDeviceOrientation);
          }
        } else {
          // Android or other devices that don't need permission
          window.addEventListener('deviceorientation', handleDeviceOrientation);
        }
      } catch (error) {
        console.error('Error requesting device orientation permission:', error);
      }
    };

    const handleFirstTouch = () => {
      requestPermission();
      window.removeEventListener('touchstart', handleFirstTouch);
    };

    if (isMobile) {
      // Request permission on first touch
      window.addEventListener('touchstart', handleFirstTouch, { once: true });
    } else {
      // Track mouse movement across entire page for desktop
      window.addEventListener('mousemove', handleMouseMove);
    }

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('deviceorientation', handleDeviceOrientation);
      window.removeEventListener('touchstart', handleFirstTouch);
    };
  }, [isMobile]);

  return (
    <section 
      className="relative w-full h-[400px] sm:h-[500px] lg:h-[600px] flex items-center justify-center overflow-hidden" 
      style={{ backgroundColor: '#140f0d', perspective: '1000px' }}
    >
      <div 
        className="w-[600px] h-[400px] sm:w-[700px] sm:h-[450px] lg:w-[800px] lg:h-[500px] rounded-full overflow-hidden transition-transform duration-200 ease-out"
        style={{
          transform: `rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
          transformStyle: 'preserve-3d'
        }}
      >
        <div 
          className="relative w-full h-full bg-cover bg-center"
          style={{ backgroundImage: 'url(/img_playa.png)' }}
        >
          {/* Gradient overlay to fade edges */}
          <div className="absolute inset-0 rounded-full" style={{
            background: `radial-gradient(circle, transparent 70%, rgba(20, 15, 13, 0.3) 85%, rgba(20, 15, 13, 0.8) 95%, #140f0d 100%)`
          }}></div>
        </div>
      </div>
    </section>
  );
}

export default Header;
